import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BagComponent } from './bag/bag.component';
import { BoxComponent } from './box/box.component';
import { BoxStackComponent } from './box-stack/box-stack.component';
import { CartDisplay } from '../../../core/types/enums';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cart-sum-display',
  templateUrl: './cart-sum-display.component.html',
  styleUrls: ['./cart-sum-display.component.scss'],
  imports: [
    MatIconModule,
    BagComponent,
    BoxComponent,
    BoxStackComponent,
    CommonModule,
  ],
})
export class CartSumDisplayComponent {
  @Input() cartDisplay: CartDisplay;
  @Input() displayPrice = true;
  @Input() count = 0;
  constructor() {}
}
